var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaeiBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    viewBox: "0 0 103.781 115.82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#595959;}.cls-2{fill:#dda012;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.74,77A19.24,19.24,0,1,1,64.91,43.74V5.61L57.63,1.4a13.09,13.09,0,0,0-11.79,0L36.43,6.84v21.9L17.08,18,5.89,24.47A13.06,13.06,0,0,0,0,34.67V80.81A13.06,13.06,0,0,0,5.89,91l10,5.77L37.16,85.45v23.62l8.68,5a13.09,13.09,0,0,0,11.79,0l7.28-4.21V71.74A19.15,19.15,0,0,1,51.74,77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.47,47.82V34.67a13.06,13.06,0,0,0-5.89-10.2L71,9.11v97.26L97.58,91a13.06,13.06,0,0,0,5.89-10.2V68L84.91,57.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.91 57.7 103.47 67.99 103.47 47.82 84.91 57.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.87 96.78 37.16 109.07 37.16 85.45 15.87 96.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.43 6.84 17.08 18.01 36.43 28.74 36.43 6.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.91,71.74v38.13l6.07-3.5V57.74A19.17,19.17,0,0,1,64.91,71.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,57.74V9.11l-6.07-3.5V43.74A19.17,19.17,0,0,1,71,57.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 51.73,
    cy: 57.74,
    r: 19.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,36.48l12.82,34.28H146l12.85-34.28h9.64V81h-7.44V65.86l.74-19.31-.19,0L148.38,81h-5L130.24,46.61l-.19,0,.74,19.22V81h-7.44V36.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.46,81c-.26-.84-.48-1.65-.65-2.45a17.92,17.92,0,0,1-.36-2.39,13.15,13.15,0,0,1-4,3.9,10.23,10.23,0,0,1-5.59,1.58q-5.16,0-7.94-2.66a9.7,9.7,0,0,1-2.77-7.32,8.65,8.65,0,0,1,3.8-7.48q3.8-2.67,10.68-2.68h5.78v-2.9a5.37,5.37,0,0,0-1.53-4.07,6.06,6.06,0,0,0-4.37-1.47,6.22,6.22,0,0,0-4,1.22,3.89,3.89,0,0,0-1.5,3.15h-7.16l0-.18q-.22-3.91,3.5-6.95a14.86,14.86,0,0,1,9.69-3,14.17,14.17,0,0,1,9.33,2.94q3.56,2.94,3.55,8.45V73.42a27.67,27.67,0,0,0,.27,3.93A21.33,21.33,0,0,0,203,81Zm-9.12-5.33a9.43,9.43,0,0,0,5.07-1.4,7.07,7.07,0,0,0,3-3.22V66.2h-5.9a7.44,7.44,0,0,0-5.08,1.6,4.86,4.86,0,0,0-1.84,3.78,3.86,3.86,0,0,0,1.24,3A5.12,5.12,0,0,0,186.34,75.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.08,81.68q-7,0-11.21-4.61a16.89,16.89,0,0,1-4.18-11.82V64a17.56,17.56,0,0,1,4.15-12,13.11,13.11,0,0,1,10.39-4.73c4.46,0,7.89,1.36,10.26,4.06s3.57,6.33,3.57,10.88v4.37H214.4l-.06.16a10.34,10.34,0,0,0,2.31,6.43,7.31,7.31,0,0,0,5.89,2.5,15.92,15.92,0,0,0,5.14-.73,17,17,0,0,0,4.13-2.11l2.39,4.87a15.33,15.33,0,0,1-5,2.8A20.61,20.61,0,0,1,222.08,81.68Zm-.85-28.4a5.57,5.57,0,0,0-4.53,2.19A10.76,10.76,0,0,0,214.49,61l.07.16h13.12v-.77a7.93,7.93,0,0,0-1.6-5.14A5.85,5.85,0,0,0,221.23,53.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.87,39.82h-7.43V33.3h7.43Zm0,41.22h-7.43V47.93h7.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaeiBox);
export default __webpack_public_path__ + "static/media/maei-box.de6658a880bc15d1b6e4020d57649e76.svg";
export { ForwardRef as ReactComponent };